import { Component, Injector, Input, Inject, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AirModel } from 'src/app/models/air/air-model';
import { AirSearchService } from 'src/app/services/air/air-search.service';
import { AirPackModel } from 'src/app/models/air/air-pack-model';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';
import { AirComponent } from '../air.component';
import { DatePipe } from '@angular/common';
import { StepperService } from 'src/app/stepper.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DocViewerDialogComponent } from 'src/app/components/doc-viewer-dialog/doc-viewer-dialog.component';
import { UserService } from 'src/app/services/user/user.service';
import { Subscription } from 'rxjs';
import { onSelectHistory, slowScrollToBottom } from 'src/app/components/search-history/search-history.component';
import { CountryService } from 'src/app/services/country/country.service';
import { TranslateService } from '@ngx-translate/core';
import { CityService } from 'src/app/services/city/city.service';
import { onSelectFixedPriceAir } from 'src/app/components/dashboard-fixed-prices/dashboard-fixed-prices.component';
import { MinDTO } from 'src/app/models/min-dto';
import { SseService } from 'src/app/services/sse-service';

@Component({
  selector: 'app-air-search',
  templateUrl: './air-search.component.html',
  styleUrls: ['./air-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AirSearchComponent extends BaseFormComponentComponent implements OnInit {

  @Input("model") model: AirModel;
  nowDate = new Date();

  termsDialog: DynamicDialogRef;
  isCheckboxSelected: boolean = false;
  serviceOptions: any[] = [];
  hideToolTip: boolean = false;
  tooltipValue: string | null = null;
  historySubscription: Subscription = null; 
  dashboardFixedPriceSubscription: Subscription = null; 

  constructor(protected injector: Injector,
    @Inject(AirComponent) private parent: AirComponent, private userService: UserService,  private countryService: CountryService, private cdr: ChangeDetectorRef,
    private stepperService: StepperService, private datePipe: DatePipe, private translateService: TranslateService, private cityService: CityService,
    private router: Router, private airSearchService: AirSearchService, private sseService: SseService) {
    super(injector)
   }

  async ngOnInit(): Promise<void> {
    const user = await this.userService.user().toPromise();
        this.hideToolTip = user.hideToolTip; 
      this.model.products = null;
      this.model.selectedProduct = null;
      this.model.quoteNo = null;
      this.model.hasInsurance = false;
      this.model.segment = null;
      
    if(!this.model.packs || this.model?.packs?.length  == 0 ) this.addPack();

    this.calculateTotals();
    setTimeout(() => this.onChangeInco(false), 1000)


    if(!this.dashboardFixedPriceSubscription) {
        this.dashboardFixedPriceSubscription = onSelectFixedPriceAir.subscribe(r => {
            if(r != null)  {
                this.model = r;
                this.parent.model = r;
                this.cdr.detectChanges();
            }         
        })
    }

    if(!this.historySubscription) {
      this.historySubscription = onSelectHistory.subscribe(r => {
          slowScrollToBottom(1000);
          const data = JSON.parse(r);
          data.readinessDate = new Date();
          this.model = data;
          this.model.segment = null;
          this.isCheckboxSelected = false;
          console.log(data, "data")
          
          this.countryService.searchCountry(data.arrivalCountry.name).toPromise().then(c => {
              this.model.arrivalCountry.code = c[0].code;
              const minArrivalPort = new MinDTO();
              minArrivalPort.id = data.arrivalPort.id;
              minArrivalPort.name = `(${data.arrivalCountry.code}) ${data?.arrivalPort?.name} (${data.arrivalPortCode})`
              this.model.arrivalPort = minArrivalPort;
          })
          
          this.countryService.searchCountry(data.departureCountry.name).toPromise().then(c => {
              this.model.departureCountry.code = c[0].code;
              const minDeparturePort = new MinDTO();
              minDeparturePort.id = data.departurePort.id;
              minDeparturePort.name = `(${data.departureCountry.code}) ${data?.departurePort?.name} (${data.departurePortCode})`
              this.model.departurePort = minDeparturePort;
          })
          this.parent.model = this.model;
          this.calculateTotals()
        
      })
  }
    


    // this.airSearchService.searchHistory().subscribe(h => console.log(h));

    /* p-calendar de dışında farklı bir component kullanılacak */
    if(this.model.readinessDate && !(this.model.readinessDate instanceof Date)) {
      this.model.readinessDate = new Date(`${String(this.model.readinessDate).substring(0,10).trim()}`);
    }

      this.parent.stepper.notShowReservation = false;


  }

  getTooltip(key: string): void {
    if (!this.hideToolTip) {
    this.tooltipValue = null;
    setTimeout(() => {
      this.tooltipValue = this.translation.instant(key)
    }, 500);
    }
  }

  onSelectZip(e: any, elementRef: any, zipField = 'departureZip' ) {
    // Eğer diğer seçildi ise postCode boş oluyor.
    if(e.isOptionOther) {
      elementRef.autoComplete.inputEL.nativeElement.value = e.name.trim().split(' ')[0]
      this.model[zipField].name = e.name.trim().split(' ')[0];
      return
    };

    elementRef.autoComplete.inputEL.nativeElement.value = e['postCode']
    this.model[zipField].name = e['postCode']
  }

  addPack() {
    if(!this.model.packs) this.model.packs = [];
    this.model.packs.push(new AirPackModel());
  }

  removePack(index: number) {
    this.model.packs.splice(index, 1);
    this.calculateTotals();
  }

 
  async onBlurTotalVolume() {
    this.parent.onBlurTotalVolume();

    // if (this.model.totalVolume == null || this.model.totalVolume === 0) return;

    // let num = Number(this.model.totalVolume);

    // if (isNaN(num)) return;

    // if(num > 10) {
    //   const message = await this.translateService.get('heightM3Message').toPromise();
    //   this.messageService.add({severity: 'warn',  key: 'html-msg', summary: '', detail: message });
    // }

    // // Round
    // num = Math.round(num * 100) / 100;

    // // Modele yaz
    // this.model.totalVolume = num;

    // // Input’a formatlı 2 basamak yaz (ngModel zaten güncelleyecek)
    // setTimeout(() => {
    //   const input: any = document.getElementById("air_total_volume");
    //   if (input) input.value = num.toFixed(2);
    // });
  }


  offClick(){
    if(this.isCheckboxSelected == false){
      this.showMessage('warn', 'wrongContractAgreement');
    }
  }

  async search(form) {



    let packHasValid = true;


      const valid = await this.isValid();

      if (!valid) return;

    this.model.isOnlinePrice = true;

    
    if (this.model.service) {

        if (this.model.service[0] !== 'D') {
            this.model.departureZipTxt = null;
            this.model.departureZip = null;
            this.model.departureAddress = null;
        }
        if (this.model.service.slice(-1) !== 'D') {
            this.model.arrivalZipTxt = null;
            this.model.arrivalZip = null;
            this.model.arrivalAddress = null;
        }
    }
    

    if(this.model.service[0] == 'D' && this.model.departureCountry?.code == 'HK') this.model.departureZipTxt = '999077'
    if(this.model.service[this.model.service.length -1] == 'D' && this.model.arrivalCountry?.code == 'HK') this.model.arrivalZipTxt = '999077'

    if(this.model.service && this.model.service[0] == 'D' && (!this.model.departureZip && !this.model.departureZipTxt)) {
      this.showMessage('warn', 'departureZipRequired');
      return;
    }
    if(this.model.service && this.model.service[this.model.service.length -1] == 'D' && (!this.model.arrivalZip && !this.model.arrivalZipTxt)) {
      this.showMessage('warn', 'arrivalZipRequired');
      return;
    }

    if(this.model.td == 'D') {
      if(!this.model.packs ||  (this.model.packs && this.model.packs.filter(f => !f.height || !f.lenght || !f.pieces || !f.perKg || !f.width).length > 0 )) {
        packHasValid = false;
      }
    }

    if(!this.model.totalVolume || !this.model.totalWeight || (!this.model.pieces && !this.model.calculatedPieces) ) {
      packHasValid = false;
    }

    if(!packHasValid) {
      this.showMessage('warn', 'totalOrUnitRequired');
      return;
    }

      if(!this.model.commodity) {
          this.showMessage("warn", "commodityRequired");
          return;
      }

    


    try {

      window.scrollTo({top: document.documentElement.scrollHeight,behavior: "smooth"});
      this.parent.productLoading = true;
      this.isLoading = true;
     


      /* Todo:
         tarih payload da 1 gün geri gidiyor nedeni anlaşılarak düzeltme uygulanacak.
       */
     // this.model.readinessDate.setDate(this.model.readinessDate.getDate() + 1);
      this.model.totalVolume = Number(String(this.model.totalVolume).replace(",","."));

      // daha önce bulunan ürün varsa siliniyor.
      this.model.products = [];
      this.model.id = null;

      // Eğer mal bedeli 500.000 USD den büyük ise fiyat talep et çıkması için arama yaptırmıyoruz.
      localStorage.setItem('search', JSON.stringify(this.model))


      this.scrollToSteps();
      this.parent.container.clear();

      if(this.model.goodPrice < 500000) {
        this.model = await this.airSearchService.search(this.model).toPromise();
      }


      this.parent.model = this.model;

      this.stepperService.changeCurrentStep(2);
      if(!this.parent.showOnlyComponent) {
        this.addQueryParam("page", "FYT")
        this.addQueryParam("op", "AIR")
        this.addQueryParam("type", `${this.model.departurePort.name.slice(0,3)}(${this.model.departureCountry.code})-(${this.model.arrivalCountry.code})${this.model.arrivalPort.name.slice(0,3)}`)
      }


    } catch (error) {
        // if (error == 'userBannedForManyRequest') {
        //     this.forceLogOut();
        // }
        this.parent.productLoading = false;
        this.isLoading = false;
    }

  }

  async getSegment(portFieldName = null) {
    if((this.model.arrivalPort && this.model.departurePort) && this.model.arrivalPort.id == this.model.departurePort.id) {
      setTimeout(() => this.model[portFieldName] = null, 100);
      this.showMessage('warn', 'samePortWarn')

    }
    if(this.model.arrivalPort && this.model.departurePort) {
      const segment = await this.airSearchService.segment(this.model.departurePort.id, this.model.arrivalPort.id).toPromise();
      this.model.segment = segment;
    }

    if(this.model.segment) {
      const discounts = await this.airSearchService.discount(this.model.segment.id).toPromise();
      this.model.discounts = discounts;
    }

  }
  forceLogOut(){
      Object.keys(localStorage).filter(k => k != 'rememberMe' && k != 'lang' && k != 'uid' && k != 'efl-saved-consent' && k != 'efl-uuid').forEach(key => localStorage.removeItem(key))
      setTimeout(() => {
        this.router.navigate(['/home']);
        }, 4000);
  }

  onChangeService() {

    if(!this.model.service || (this.model.service && this.model.service == 'DTD')) return;

    if(this.model.service[0] == 'D') {
      this.model.arrivalAddress = null;
      this.model.arrivalZip = null;
    }

    if(this.model.service[this.model.service.length -1] == 'D') {
      this.model.departureAddress = null;
      this.model.departureZip = null;
    }


  }
  onChangeInco(clearService = true) {
    if(clearService) this.model.service = null;
    this.model.isPortLoad = false;
    const serviceTypes = JSON.parse(localStorage.getItem('marketAirServiceType'));
    switch (this.model.incoterm) {
        case "EXW":
            this.serviceOptions = [ ...serviceTypes.filter(f => ['DTA', 'DTD'].includes(f.code)) ];
            break;
        case "FCA":
            this.serviceOptions = serviceTypes.filter(f => ['ATA', 'ATD'].includes(f.code));
            break;
        case "FOB":
            this.serviceOptions = serviceTypes.filter(f => ['ATA', 'ATD'].includes(f.code));
            break;
        case "FAS":
            this.serviceOptions = serviceTypes.filter(f => ['ATA', 'ATD'].includes(f.code));
            break;
        case "CFR":
            this.serviceOptions = serviceTypes.filter(f => ['DTA', 'ATA'].includes(f.code));
            break;
        case "CIF":
            this.serviceOptions = serviceTypes.filter(f => ['DTA', 'ATA'].includes(f.code));
            break;
        case "CPT":
            this.serviceOptions = serviceTypes.filter(f => ['DTA', 'ATA'].includes(f.code));
            break;
        case "CIP": 
            this.serviceOptions = serviceTypes.filter(f => ['DTA', 'ATA'].includes(f.code));
            break;
        case "DAP": 
            this.serviceOptions = serviceTypes.filter(f => ['DTD', 'ATD'].includes(f.code));
            break;
        case "DDP": 
            this.serviceOptions = serviceTypes.filter(f => ['DTD', 'ATD'].includes(f.code));
            break;
        case "DPU": 
            this.serviceOptions = serviceTypes.filter(f => ['DTD', 'ATD'].includes(f.code));
            break;
        default:
            this.serviceOptions = serviceTypes;
            break;
      }

    
    
  }


  onChangeTD(td: string) {
    this.model.td = td;
    this.model.packs = [];
    this.model.packingType = null;
    this.model.calculatedPieces = 0;
    this.model.pieces = 0;

    this.model.totalVolume = null;
    this.model.cwg = 0;
    this.model.totalWeight = null;

    if(td == 'D') this.addPack();
  }

  onChangeDepartureCountry() {
    this.model.departurePort = null;
    this.model.departureZip = null;
    this.model.departureCity = null;
  }
  onChangeArrivalCountry() {
    this.model.arrivalPort = null;
    this.model.arrivalZip = null;
    this.model.arrivalCity = null;

  }

    onSelectZipToAddress(e: any, elementRef: any, zipField = 'departureZip' ){
        if (zipField == 'departureZip') this.model.departureAddress = e.name;
        if (zipField == 'arrivalZip') this.model.arrivalAddress = e.name;
        this.onSelectZip(e, elementRef, zipField);
    }

  calculateTotals(event:any = null) {
    this.parent.calculateTotals();
  }

  onVolumeInput(event: any) {
    let val = event.target.value;
    val = val.replace(/,/g, '.');
    val = val.replace(/[^0-9.]/g, '');
    const parts = val.split('.');
    if (parts.length > 2) {
      val = parts[0] + '.' + parts.slice(1).join('');
    }

    event.target.value = val;
    this.model.totalVolume = val;
    this.calculateTotals(event);
}

  showUseTrms() {
    this.termsDialog = this.dialogService.open(DocViewerDialogComponent, { header: "view", showHeader: false, modal:true, closable: true,  width: '50%', height: '100%',  data: {filePath: `/assets/data/documents/terms_${this.translation.currentLang}.html`}});

}
  deletePortByField(event: any ,field: string) {
      // setTimeout(()=> {
      //     if (!event?.id){
      //         this.model[field] = null;
      //     }
      // }, 100);
  }
  async onSelectDepaturePort(data: any) {

      if(data.cityId && data.cityId != 0) {
        const city =   await this.cityService.getById({cityId: data.cityId}).toPromise();
        if(city) this.model.departureCity = city;
      }
        if(data.countryId && data.countryId != 0) {
        const country =   await this.countryService.getById({countryId: data.countryId}).toPromise();
        if(country) this.model.departureCountry = country;
      }
  }
    
  async onSelectArrivalPort(data: any) {

      if(data.cityId && data.cityId != 0) {
        const city =   await this.cityService.getById({cityId: data.cityId}).toPromise();
        if(city) this.model.arrivalCity = city;
      }
        if(data.countryId && data.countryId != 0) {
        const country =   await this.countryService.getById({countryId: data.countryId}).toPromise();
        if(country) this.model.arrivalCountry = country;
      }
  }

  scrollToSteps() {
    const element = document.querySelector('x-p-steps');  
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
